export default function addComingSoonTags() {
    // add 'Coming Soon' text to future learning path cards
    // may be deprecated in the future
    try {
        let comingSoonBtn = document.querySelector('#main-container[data-tags="coming-soon"] .purchase-button-full-text');
        comingSoonBtn.innerText = 'Coming Soon';
    } catch (e) {
        console.warn("No additional card tags to update...", e);
    }
};
